import { observer } from 'mobx-react-lite'
import React from 'react'

import { CreateTriviaListView } from './create-trivia-list-view'
import { SYSTEM_TRIVIA_LIST_IMAGES_FOLDER } from '../edit-trivia-list/edit-trivia-list-route-admin'
import { useCreateSystemTriviaList } from '../queries/useCreateSystemTriviaList'

export const CreateTriviaListRouteAdmin = observer(
  function CreateTriviaListRouteAdmin(): React.ReactElement {
    const { mutateAsync: createTriviaList } = useCreateSystemTriviaList()

    return (
      <CreateTriviaListView
        baseUrl='/admin/'
        createTriviaList={createTriviaList}
        imageStorageFolder={SYSTEM_TRIVIA_LIST_IMAGES_FOLDER}
      />
    )
  }
)
